import React from "react";
import { GiCheckMark } from "react-icons/gi";
import "../../css/success.css";

function Success() {


  return (
    <>
      <div className="order-success-page">
        <div className="container m-auto">
          <div className="row mt-0">
            <div className="col-8 mx-auto">
              <div className="order-success-card">
                <div className="success-heading">
                  <h1>Your order has been placed successfully</h1>
                </div>
                <div className="success-svg">
                  <GiCheckMark size={40}/>
                </div>
                <div className="success-thank-you">
                  <h2>Thank you for your purchase !</h2>
                </div>
                <div className="success-email-confirm-msg">
                  <p>
                    You will receive an order confirmation email with details of
                    your order.
                  </p>
                </div>
                <button className="success-home-btn" type="button">
                  <a href="/">Continue Shopping</a>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Success;
